module.exports = __webpack_public_path__ + "img/MOUSTACHES SET 1 LIME.42a4115.svg";